<template>
  <v-container class="pa-0 offers">
    <div v-if="getOfferCount === 0">
      Alle aanvragen zijn door jou verwerkt. Op dit moment zijn er geen nieuwe
      aanvragen die overeenkomen met jouw profiel instellingen (diagnostiek en
      behandeling).<br /><br />
      Kijk regelmatig over er nieuwe aanvragen zijn. Je kunt ook je profiel
      aanpassen om mogelijk meer aanvragen te zien die overeenkomen met je
      competentie.<br /><br /><br />
      <v-btn
        class="no-border-shadow no-margin btn-blue full-width-login"
        @click.stop="$router.push({ name: 'profile' })"
      >
        Profiel aanpassen &rsaquo;
      </v-btn>
      <br /><br />
      <v-btn
        class="no-border-shadow no-margin btn-blue full-width-login"
        color="success"
        @click.stop="$router.push({ name: 'home' })"
      >
        Startpagina &rsaquo;
      </v-btn>
    </div>

    <div v-if="getOfferCount > 0">
      <div class="padding-15-no-bottom background-white">
        <h1>Aanbod {{ currentOffer + 1 }} / {{ getOfferCount }}</h1>
        <img src="/img/swipe.png" class="swipe-icon" />
        <v-progress-linear
          v-model="progress"
          height="15"
          class="rounded-progress"
          color="cedinzorg-red-accent"
        ></v-progress-linear>
      </div>

      <OfferTabs v-model="currentOffer" :offers="offers">
        <template v-slot:buttons>
          <v-btn
            color="success"
            class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
            dark
            @click.stop="showAvailableForm = true"
            >Inschrijven
          </v-btn>
          <br /><br />
          <v-btn
            color="orange"
            class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
            dark
            @click.stop="nextOffer()"
            v-if="hasNext"
            >Nu niet
          </v-btn>
          <br v-if="hasNext" /><br v-if="hasNext" />
          <v-btn
            color="error"
            class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
            dark
            @click.stop="declineOffer()"
            >Afwijzen
          </v-btn>
        </template>
      </OfferTabs>
      <!------------------------ Available form ------------------->
      <v-dialog
        v-model="showAvailableForm"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark class="no-border-shadow cedinzorg-lbue">
            <v-btn icon dark @click="showAvailableForm = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Inschrijven op aanvraag</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container grid-list-md>
            <v-form
              ref="availableForm"
              v-model="availableFormIsValid"
              lazy-validation
            >
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <!---------------- date picker ------------------->
                  <v-dialog
                    ref="datepickerdialog"
                    v-model="showDatepicker"
                    :return-value.sync="reaction.start_date"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="reaction.start_date"
                        label="Ik kan starten per"
                        readonly
                        :rules="dateRules"
                        required
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="reaction.start_date"
                      scrollable
                      locale="nl-nl"
                      :min="now"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        color="primary"
                        @click="showDatepicker = false"
                        >Annuleren
                      </v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="
                          $refs.datepickerdialog.save(reaction.start_date)
                        "
                        >OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <!---------------- / date picker ------------------->
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Hoeveel uur ben je beschikbaar (per week)"
                    v-model="reaction.availability"
                    :rules="availabilityRules"
                    required
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    label="Toelichting"
                    v-model="reaction.notes"
                    placeholder="Geef hier eventueel aan waarom je je op deze aanvraag wilt inschrijven."
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-card-actions>
                    <v-btn
                      color="success"
                      class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
                      dark
                      @click.stop="postReaction(true)"
                      >Inschrijven
                    </v-btn>
                    <br /><br />
                    <v-btn
                      color="cancel"
                      class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
                      dark
                      @click.stop="showAvailableForm = false"
                      >Annuleren
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import OfferTabs from "../components/OfferTabs";

export default {
  components: { OfferTabs },
  data() {
    return {
      showAvailableForm: false,
      availableFormIsValid: true,
      showDatepicker: false,
      reaction: this.createEmptyReaction(),
      availabilityRules: [
        v => !!v || "Beschikbaarheid is verplicht",
        v => !isNaN(v) || "Beschikbaarheid moet een getal zijn"
      ],
      dateRules: [v => !!v || "Datum is verplicht"]
    };
  },
  created() {
    this.$store.commit("offer/SET_CURRENT_OFFER", 0);
    this.fetchOffers();
  },
  watch: {
    $route: "fetchOffers"
  },
  computed: {
    ...mapGetters("offer", ["getOfferCount"]),
    ...mapState("offer", ["offers"]),
    ...mapState("user", ["user"]),
    currentOffer: {
      get() {
        console.log("currentOffer.get");
        return this.$store.state.offer.currentOffer;
      },
      set(value) {
        console.log("Offers currentOffer.set newValue", value);
        this.$store.commit("offer/SET_CURRENT_OFFER", value);
      }
    },
    hasNext: function() {
      return this.currentOffer + 1 < this.getOfferCount;
    },
    hasPrev: function() {
      return this.currentOffer > 0;
    },
    progress: function() {
      return Math.round(((this.currentOffer + 1) / this.getOfferCount) * 100);
    },
    now: function() {
      return moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    nextOffer() {
      if (this.hasNext) this.currentOffer = this.currentOffer + 1;
    },
    fetchOffers(reset = false) {
      this.$store.dispatch("offer/fetch", reset).catch(error => {
        let notification = {
          type: "error",
          message: "Er ging iets fout!"
        };
        this.$store.dispatch("notification/add", notification);
      });
    },
    createEmptyReaction() {
      let userId = this.$store.state.user.user.id;
      return {
        user_id: userId,
        is_available: true,
        notes: "",
        availability: ""
      };
    },
    declineOffer() {
      let reaction = this.reaction;
      reaction.is_available = false;
      reaction.offer_id = this.offers[this.currentOffer].id;
      this.$store
        .dispatch("offer/postReaction", reaction)
        .then(() => {
          this.reaction = this.createEmptyReaction();
          this.showAvailableForm = false;
        })
        .catch(() => {
          let notification = {
            type: "error",
            message: "Er ging iets fout!"
          };
          this.$store.dispatch("notification/add", notification);
        });
    },
    postReaction(isAvailable) {
      if (
        (isAvailable && this.$refs.availableForm.validate()) ||
        (!isAvailable && this.$refs.unavailableForm.validate())
      ) {
        let reaction = this.reaction;
        reaction.is_available = isAvailable;
        reaction.offer_id = this.offers[this.currentOffer].id;
        this.$store
          .dispatch("offer/postReaction", reaction)
          .then(() => {
            console.log(
              "After post reaction:",
              this.currentOffer,
              this.offers.length
            );

            this.$store.dispatch("notification/add", {
              type: "success",
              message: "Bedankt voor je reactie!"
            });
            this.reaction = this.createEmptyReaction();
            this.showAvailableForm = false;
            console.log(
              "After post reaction, END: ",
              this.currentOffer,
              this.offers.length
            );
          })
          .catch(error => {
            let notification = {
              type: "error",
              message: "Er ging iets fout!"
            };
            this.$store.dispatch("notification/add", notification);
          });
      }
    }
  }
};
</script>
